var render = function render(){var _vm=this,_c=_vm._self._c;return _c('status-bar',{model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('v-switch',{attrs:{"input-value":_vm.value,"label":_vm.label,"tabindex":_vm.tabindex,"autofocus":_vm.autofocus},on:{"change":function($event){return _vm.updateValue($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }